import {useQuery} from "@tanstack/react-query";

import {fetchRoles, fetchRolesByOwner} from "../../services/network/role-api";
import {ROLE_ENDPOINTS} from "../../services/network/endpoints";

export function useFetchRoles() {
    const {data, error, isLoading} = useQuery({
        queryKey: ["/roles"],
        queryFn: () => fetchRoles(),
    });

    return {
        rolesData: data,
        rolesError: error,
        rolesIsLoading: isLoading,
    };
}

export function useFetchRolesV2(isAdministrator: boolean) {
    const {data, error, isLoading} = useQuery({
        queryKey: [ROLE_ENDPOINTS.GET_BY_OWNER],
        queryFn: () => fetchRolesByOwner(),
        enabled: isAdministrator,
        select: (response) => response.data?.map(role => ({
            id: role.id,
            name: role.name
        })) || []
    });

    return {
        rolesData: data,
        rolesError: error,
        rolesIsLoading: isLoading,
    };
}